import { render, staticRenderFns } from "./DashboardCellArchive.vue?vue&type=template&id=895cb80c&scoped=true&"
import script from "./DashboardCellArchive.vue?vue&type=script&lang=js&"
export * from "./DashboardCellArchive.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "895cb80c",
  null
  ,true
)

export default component.exports